import {
    GET_BOOKING_FORM_REQUEST,
    GET_BOOKING_FORM_SUCCESS,
    GET_BOOKING_FORM_FAIL, UPDATE_BOOKING_FORM_DATA
} from "../constants/bookingFormConstants";
import {requestApi} from "../../utils/utils";

export const getBookingFormData = (guestId, accessToken = null) => async (dispatch) => {
    dispatch({type: GET_BOOKING_FORM_REQUEST});

    try {
        const accessQuery = accessToken ? `?access=${accessToken}` : '';
        const {data: guestData} = await requestApi(`/guest/get/${guestId}${accessQuery}`);
        if (guestData.status === 'success') {
            const bookingId = guestData.guest.bookFk;
            const {data: bookingData} = await requestApi(`/booking/get/${bookingId}${accessQuery}`);
            if (bookingData.status !== 'success')
                throw new Error('Unable to find booking');

            // guestData.guest['height'] = `6' 4"`;
            dispatch({
                type: GET_BOOKING_FORM_SUCCESS,
                payload: {
                    booking: bookingData.booking,
                    form: guestData.guest,
                }
            });


        }
    } catch (e) {
        dispatch({type: GET_BOOKING_FORM_FAIL});
    }
};

export const updateBookingFormData = (params, guestId) => async (dispatch) => {
    try {
        const {data} = await requestApi(`/guest/save/${guestId}`, 'POST', params);

        if (data.status === 'success') {
            dispatch({
                type: UPDATE_BOOKING_FORM_DATA,
                payload: data.update
            });
        }
    } catch (e) {
        throw new Error('Unable to update guest form.');
    }
};